import { NgModule } from '@angular/core';

import { SwipeDirective } from './swipe.directive';

@NgModule({
  exports: [SwipeDirective],
  declarations: [SwipeDirective],
})
export class SwipeModule {
}
